<template>
  <div class="bussiness_suggest">
    <el-divider content-position="left">续费建议</el-divider>
    <el-collapse v-model="activeOpen">
      <el-collapse-item title="高级筛选" name="1">
        <div class="changeHeight m-tabs-content">
          <el-row :gutter="20">
            <el-col :span="2" class="tr m-label text_right">公司名称</el-col>
            <el-col :span="4">
              <el-select
                v-model="searchArr.company_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入公司字号筛选公司"
                size="mini"
                clearable
                :remote-method="remoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="company in companies"
                  :key="company.id"
                  :label="company.company_name"
                  :value="company.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">开始时间</el-col>
            <el-col :span="4">
              <div>
                <el-date-picker
                  v-model="searchArr.start_time"
                  type="month"
                  size="mini"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  @change="pickerDataChange"
                  placeholder="选择商机开始时间"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">过期时间</el-col>
            <el-col :span="4">
              <div>
                <el-date-picker
                  v-model="searchArr.end_time"
                  type="month"
                  size="mini"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  @change="pickerDataChange"
                  placeholder="选择商机过期时间"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="2" class="tr m-label text_right">建议人</el-col>
            <el-col :span="4">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.suggest_uid"
                placeholder="请选择商机创建人"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">当前单品</el-col>
            <el-col :span="4">
              <el-select
                :filterable="true"
                collapse-tags
                v-model="searchArr.current_item"
                placeholder="请选择单品"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in Items"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">当前套餐</el-col>
            <el-col :span="4">
              <el-select
                :filterable="true"
                collapse-tags
                v-model="searchArr.current_combo"
                placeholder="请选择套餐"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in Combos"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align: center;">
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleCloseSearch"
                >清除</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="middle-table">
    <el-table
      :data="suggestData"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      height="calc(100vh - 306px)"
    >
      <el-table-column fixed width="220" label="公司名称">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.company ? scope.row.company.company_name : ''"
            placement="top"
          >
            <div class="company_hover">
              <span class="count_style" style="display: inherit">
                {{ scope.row.company ? scope.row.company.company_name : "" }}
              </span>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"
            ><i
              class="el-icon-document-copy"
              style="margin-left: 0.1rem; cursor: pointer"
              @click="copySome(scope.row.company.company_name)"
            ></i
          ></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column width="100" label="开始时间" prop="start_time"></el-table-column>
      <el-table-column width="100" label="过期时间" prop="end_time"></el-table-column>
      <el-table-column width="140" label="创建时间" prop="created_at">
        <template slot-scope="scope">
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        width="250"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="item.prop === 'combo_name'"
            :content="scope.row.combo_name ? scope.row.combo_name.combo_name : ''"
            placement="top"
          >
            <span class="count_style">{{
              scope.row.combo_name ? scope.row.combo_name.combo_name : ""
            }}</span>
          </el-tooltip>
          <el-tooltip
            v-else-if="item.prop === 'item_name'"
            :content="scope.row.item_name ? scope.row.item_name.item_name : ''"
            placement="top"
          >
            <span class="count_style">{{
              scope.row.item_name ? scope.row.item_name.item_name : ""
            }}</span>
          </el-tooltip>
          <el-tooltip v-else :content="scope.row[item.prop]" placement="top">
            <span class="count_style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑建议表" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleContactOpen(scope.$index, scope.row)"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="编辑"
      :visible.sync="upDrawer"
      direction="rtl"
      :before-close="handleUpBeforeClose"
      size="35%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs style="padding: 0 0.2rem 0 0.4rem" v-model="activeName">
          <!-- <el-tab-pane label="登记表信息" name="first"> -->
          <div class="tabs_line">
            <div class="lines"></div>
            <h3 class="tabs-title">基础信息</h3>
          </div>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="6" class="m-label">开始时间：</el-col>
            <el-col :span="16">
              <div>
                <el-date-picker
                  v-model="upData.start_time"
                  type="month"
                  size="mini"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-01"
                  @change="SaveChangeMethods('start_time', '开始时间')"
                  placeholder="选择建议开始时间"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="m-label">过期时间：</el-col>
            <el-col :span="16">
              <div>
                <el-date-picker
                  v-model="upData.end_time"
                  type="month"
                  size="mini"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-01"
                  @change="SaveChangeMethods('end_time', '过期时间')"
                  placeholder="选择建议开始时间"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="m-label">当前套餐：</el-col>
            <el-col :span="16">
              <el-select
                :filterable="true"
                collapse-tags
                v-model="upData.current_combo"
                placeholder="请选择套餐"
                size="mini"
                @change="SaveChangeMethods('current_combo', '当前套餐')"
                clearable
              >
                <el-option
                  v-for="item in Combos"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="m-label">当前单品：</el-col>
            <el-col :span="16">
              <el-select
                multiple
                :filterable="true"
                collapse-tags
                v-model="upData.current_item"
                placeholder="请选择单品"
                size="mini"
                @change="SaveChangeMethods('current_item', '当前单品')"
                clearable
              >
                <el-option
                  v-for="item in Items"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="m-label">建议内容：</el-col>
            <el-col :span="16">
              <el-input
                type="textarea"
                :autosize="textareaSize2"
                v-model="upData.suggest_content"
                @change="SaveChangeMethods('suggest_content', '建议内容')"
                clearable
              ></el-input>
            </el-col>
          </el-row>
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane label="历史信息" name="second">
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import DateFormatter from 'common/DateFormatter'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "BussinessSuggest",
  components: {DateFormatter},
  data() {
    return {
      activeOpen: '',
      inputSize: "small",
      users: [],
      Combos: [],
      companies: [],
      suggestData: [],
      Items: [],
      loading: false,
      upDrawer: false,
      activeName: "first",
      textareaSize2: {
        minRows: 2,
        maxRows: 4,
      },
      col: [
        {
          label: "当前服务套餐",
          prop: "combo_name",
          display: false,
        },
        {
          label: "当前服务单品",
          prop: "item_str",
          display: false,
        },
        {
          label: "建议内容",
          prop: "suggest_content",
          display: false,
        },
      ],
      searchArr: {
        suggest_uid: "",
        company_id: "",
        start_time: "",
        end_time: "",
        current_combo: "",
        current_item: "",
        created_at: "",
      },
      upData: {
        id: null,
        index: null,
        start_time: "",
        end_time: "",
        current_combo: "",
        current_item: [],
        suggest_content: "",
        company_id: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  methods: {
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getBussinChangeData() {
      this.$axios
        .get(
          "/api/finance/suggest_list?page=" + this.pageOption.currentPage + this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.users = data.data.users;
            this.Combos = data.data.combos;
            this.Items = data.data.items;
            this.suggestData = data.data.list.data;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    SaveChangeMethods(field, fieldName) {
      this.$axios
        .put("/api/finance/update_suggest/" + this.upData.id, {
          fieldName: field,
          value: this.upData[field],
          old: this.suggestData[this.upData.index][field],
          typeName: fieldName,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.getBussinChangeData();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleASearSub() {
      this.activeOpen = '';
      this.pageOption.currentPage = 1;
      this.getBussinChangeData();
    },
    handleCloseSearch() {
      this.activeOpen = '';
      this.searchArr.start_time = "";
      this.searchArr.end_time = "";
      this.searchArr.company_id = "";
      this.searchArr.created_uid = "";
      this.searchArr.current_combo = "";
      this.searchArr.current_item = "";
      this.searchArr.created_at = "";
      this.getBussinChangeData();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getBussinChangeData();
    },
    clearUpdata() {
      this.upData.id = null;
      this.upData.index = null;
      this.upData.start_time = "";
      this.upData.end_time = "";
      this.upData.suggest_content = "";
      this.upData.current_combo = "";
      this.upData.current_item = [];
    },
    handleUpBeforeClose(done) {
      this.clearUpdata();
      done();
    },
    handleContactOpen(index, row) {
      this.upData.id = row.id;
      this.upData.index = index;
      this.upData.company_id = row.company_id;
      this.upData.suggest_content = row.suggest_content;
      this.upData.current_combo = row.combo_name ? row.combo_name.combo_id : "";
      this.upData.current_item = row.upData_item_ids ? row.upData_item_ids : "";
      this.upData.start_time = row.start_time;
      this.upData.end_time = row.end_time;
      this.upDrawer = true;
    },
    pickerDataChange(val) {
      if (!val) {
        this.searchArr.created_at = "";
      } else {
        this.searchArr.created_at = val;
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.getBussinChangeData();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>
<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-select
  width: 100%
.bussiness_suggest >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.bussiness_suggest
  marginLeft()
  .count_style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.search-row .el-col
  margin-bottom: .2rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.el-date-editor
  width: 100%
.bussiness_suggest >>> .el-collapse-item__wrap
  position: fixed
  width: -webkit-fill-available;
  z-index: 222 !important
.middle-table
  z-index: 1
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
.middle-table
  z-index: 1
</style>



// WEBPACK FOOTER //
// src/pages/bussiness_suggest/BussinessSuggest.vue